export function normalizeSearchResponse(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;

  return data;
}

export function searchResponseIsEmpty(data) {
  const normalized = normalizeSearchResponse(data);

  return Array.isArray(normalized) && normalized.length === 0;
}
